/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum ProductType {
    Batter = 'Batter',
    Foil = 'Foil',
    Boxes = 'Boxes',
    Pallets = 'Pallets',
    AmbientFinished = 'Ambient_Finished',
    FrozenFinished = 'Frozen_Finished',
    FrozenBulk = 'Frozen_Bulk',
    Oil = 'Oil',
    Salt = 'Salt',
    IngredientsOther = 'Ingredients_Other',
    Transport = 'Transport'
}



